import React from 'react';
import { NavLink } from 'react-router-dom';

const HomeRegister = () => {
		return (
			<section className="home-register-panel">
				<h4 className="hr-title">Ready?</h4>
                <NavLink to="/register">
                    <button className="header-btn hr-button">Register Free</button>
                </NavLink>
			</section>
		);
}

export default HomeRegister;



// WEBPACK FOOTER //
// ./src/components/home/HomeRegister.js